module.exports = __webpack_public_path__ + "static/ux_1_eg-6f4b6b29a5e4db440474c78e2552aec6.png";